import axiosCommonApi from '@apis/axiosCommonApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'
import ApisServiceAuth from '../axiosAuthApi'

const CHUNG = '/chung'

export function getDetailDuAn(id: string) {
  try {
    return axiosCommonApi.get('/du-an/' + id + '/get-chi-tiet-du-an')
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function getListDuAn(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosCommonApi.get('/du-an/filter-du-an', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function getDetailChiNhanh(id: string) {
  try {
    return ApisServiceAuth.get('/chi-nhanh/' + id + '/get-chi-tiet-chi-nhanh')
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function getListChiNhanh(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisServiceAuth.get('/chi-nhanh/filter-chi-nhanh', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function getDetailHeThong(id: string) {
  try {
    return ApisServiceAuth.get('/he-thong/' + id + '/get-chi-tiet-he-thong')
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function getListHeThong(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisServiceAuth.get('/he-thong/filter-he-thong', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function changeHeThong(projectId: number) {
  return ApisServiceAuth.put('/user/' + projectId + '/doi-he-thong')
}

export function uploadImage(image: File) {
  try {
    const formData = new FormData()
    formData.append('image', image)
    return axiosCommonApi.post(`${CHUNG}/tai-len-hinh`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function configRateCnyVnd(rateCnyVnd: number) {
  try {
    return axiosCommonApi.put(`${CHUNG}/cau-hinh-ty-gia-cny-vnd`, { rateCnyVnd })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function configShutdownSystem(shutdownSystem: boolean) {
  try {
    return axiosCommonApi.put(`${CHUNG}/cau-hinh-dong-he-thong`, { shutdownSystem })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function getSettings() {
  try {
    return axiosCommonApi.get(`${CHUNG}/cai-dat`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function getMyNotifications(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosCommonApi.get(`${CHUNG}/thong-bao-cua-toi`, {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function readNotification(notificationId: number) {
  try {
    return axiosCommonApi.put(`${CHUNG}/${notificationId}/doc-thong-bao`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function filterLog(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosCommonApi.get(`${CHUNG}/loc-nhat-ky`, {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
